import { TranslateService } from '@ngx-translate/core';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService, CredentialsService } from '@app/login';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { MatSelect } from '@angular/material/select';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import {
  FINANCE,
  FINANCE_AMOUNT,
  FORM_AUTO,
  FORM_CONSUMO,
  OPERATIVE_EIC,
  OPERATIVE_ESC,
  PENDIENTES_DE_DATOS,
  POINT_OF_SALE,
  REQUEST_DATA,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
  TYPE_BALANCE_S,
  TYPE_BALANCE_T,
} from '@app/@core/constants/requests.constants';
import { RequestBalanceDTO, StatesFieldsFrontDTO } from '@app/requests/model/requests-model';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

@Component({
  selector: 'scf-financing-amount',
  templateUrl: './financing-amount.component.html',
  styleUrls: ['./financing-amount.component.scss'],
})
export class FinancingAmountComponent implements OnInit, OnChanges {
  @Input() public mode: string = 'new';
  @Input() public request: any = null;
  @Input() requestOperative: string = '';
  @Input() state: CommonDataDTO;
  @Input() public priceValueRef: string = null;
  @Input('isDisableCalculateButton') set dataIsDisableCalculateButton(data: any) {
    if (data) {
      this.isDisableCalculateButton = data;
    }
  }
  @Input('establishment') set dataEstablishment(data: any) {
    if (data) {
      this.selectedEstablishment = data;
    }
  }
  @Input('typeBalance') set dataTypeBalance(data: any) {
    if (data) {
      this.typeBalance = data;
    }
  }
  @Input('maxAmount') set dataMaxAmount(data: any) {
    if (data) {
      this.maxAmount = parseFloat(data.toString());
      console.log(data);
      let amount =
        this.financingAmountDataForm && this.financingAmountDataForm.controls.requestedAmount.value
          ? this.financingAmountDataForm.controls.requestedAmount.value.toString().replaceAll('.', '').replace(',', '.')
          : null;
      let price =
        this.financingAmountDataForm && this.financingAmountDataForm.controls.priceProduct.value
          ? this.financingAmountDataForm.controls.priceProduct.value.toString().replaceAll('.', '').replace(',', '.')
          : null;
      if (amount && this.isMaxAmountNotValid(parseFloat(amount))) {
        this.financingAmountDataForm.controls.requestedAmount.markAsTouched();
        if (price && parseFloat(amount) < parseFloat(price)) {
          setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ MaxAmount: true }));
        }
      } else if (
        this.financingAmountDataForm &&
        this.financingAmountDataForm.controls.requestedAmount.hasError('MaxAmount')
      ) {
        setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors(null));
      }
    }
  }

  @Input('markTouched') set datamarkTouched(data: boolean) {
    if (data) {
      if (this.financingAmountDataForm.controls.priceProduct.value === null) {
        this.financingAmountDataForm.controls.priceProduct.setErrors({ required: true });
      }

      if (this.financingAmountDataForm.controls.requestedAmount.value === null) {
        this.financingAmountDataForm.controls.requestedAmount.setErrors({ required: true });
      }

      if (this.financingAmountDataForm.controls.product.value === null) {
        this.financingAmountDataForm.controls.product.setErrors({ required: true });
      }

      if (this.financingAmountDataForm.controls.lineProduct.value === null) {
        this.financingAmountDataForm.controls.lineProduct.setErrors({ required: true });
      }
    }
  }
  @ViewChild('priceProduct') priceProductElement: ElementRef;
  @ViewChild('start') startElement: ElementRef;

  @Output() public isFinishedLoading = new EventEmitter<any>();
  @Output() public sendOperative = new EventEmitter<any>();
  @Output() public sendProductLine = new EventEmitter<any>();
  @Output() public sendRequestedAmount = new EventEmitter<any>();
  @Output() public sendPriceProduct = new EventEmitter<any>();
  @Output() public sendStart = new EventEmitter<any>();
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public sendDataFinance = new EventEmitter<any>();

  isRepsol: boolean;
  typeBalance: RequestBalanceDTO;
  isDisableCalculateButton: boolean = true;
  isGS: boolean;
  userInfo: any;
  maxAmount: any;
  operative: any;
  isComponentLoading: boolean = false;
  selectedProductLine: string;
  productList: CommonDataDTO[];
  selectedEstablishment: string;
  commercialProductList: CommonDataDTO[] = [];
  lineProductList: CommonDataDTO[] = [];
  calculatorData: boolean = false;
  isCalculator: boolean = false;
  disabledFinancingAmount: boolean = true;
  importeMaxVideoSelfing: number;
  priceValid: boolean = true;
  amountValid: boolean = true;
  private isCombosUpdateLoading: boolean = false;
  public financingAmountDataForm: FormGroup;
  private isLineProductLoading: boolean = false;
  private isChangesLoading: boolean = false;
  public videoSelfingIDInit: string = '';

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private credentials: CredentialsService,
    private authenticationService: AuthenticationService,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    private combosStore: CombosStore,
    private requestStore: RequestsSaveSendStore,
    private requestsGetDataApi: RequestsGetDataApi
  ) {
    this.userInfo = this.credentials.credentials;
    this.isRepsol = this.authenticationService.isRepsol();
    this.isGS = this.authenticationService.isGS();
  }

  ngOnInit(): void {
    this.financingAmountDataForm = this.formBuilder.group(
      {
        priceProduct: ['', Validators.compose([Validators.required, Validators.max(999999999999)])],
        requestedAmount: ['', Validators.compose([Validators.required, Validators.max(999999999999)])],
        start: [{ value: '', disabled: true }],
        lineProduct: ['', Validators.required],
        product: ['', Validators.required],
      },
      {
        updateOn: 'change',
        validators:
          this.requestStore.getMarcaFormulario() === FORM_AUTO
            ? [this.customValidators.isRequestedAmountAutosValid()]
            : null,
      }
    );

    if (
      this.requestStore.getMarcaFormulario() === FORM_AUTO ||
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO
    ) {
      this.requestStore.isCalculatorData$.subscribe((data) => {
        this.isCalculator = data;
      });
      if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
        this.isCalculator
          ? this.updateCombos(this.requestStore.listaFormulariosAutos[FINANCE_AMOUNT])
          : this.requestStore.setFormularioAutos(this.financingAmountDataForm, FINANCE_AMOUNT);
      } else {
        this.isCalculator
          ? this.updateCombos(this.requestStore.listaFormulariosConsumo[FINANCE_AMOUNT])
          : this.requestStore.setFormularioConsumo(this.financingAmountDataForm, FINANCE_AMOUNT);
      }
    }

    this.requestStore.listaFormulariosConsumo[POINT_OF_SALE]?.statusChanges.subscribe(() => {
      const isInvalid = this.requestStore.listaFormulariosConsumo.findIndex(
        (form, i) => i === POINT_OF_SALE && form?.status === 'INVALID'
      );

      if (isInvalid >= 0) {
        this.isDisableCalculateButton = true;
      } else {
        this.isDisableCalculateButton = false;
      }
    });

    this.financingAmountDataForm.valueChanges.subscribe(() => {
      this.sendRequestedAmount.emit(
        this.financingAmountDataForm.controls.requestedAmount.value?.replace('€', '').trim()
      );
      this.sendPriceProduct.emit(this.financingAmountDataForm.controls.priceProduct.value?.replace('€', '').trim());
      this.sendStart.emit(this.financingAmountDataForm.controls.start.value?.replace('€', '').trim());

      if (this.requestStore.listaFormulariosConsumo[REQUEST_DATA]) {
        this.requestStore.listaFormulariosConsumo[REQUEST_DATA].controls.expirationMonth.reset();
      }
      if (this.requestStore.listaFormulariosConsumo[FINANCE]) {
        this.requestStore.listaFormulariosConsumo[FINANCE].reset();
      }

      if (this.typeBalance?.balance === TYPE_BALANCE_S) {
        this.sendOperative.emit(null);
      }
    });

    this.financingAmountDataForm.statusChanges.subscribe(() => {
      this.sendDataFinance.emit(null);
      if (this.financingAmountDataForm) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.financingAmountDataForm, id: FINANCE_AMOUNT });
      }
    });

    this.requestStore.importeMaxVideoSelfing$.subscribe((value) => {
      if (value) {
        this.importeMaxVideoSelfing = parseInt(value);
      }
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      this.setValuesToForm();
      if (
        this.state.id !== PENDIENTES_DE_DATOS ||
        (this.state.id === PENDIENTES_DE_DATOS && this.requestOperative === 'EIC')
      ) {
        this.financingAmountDataForm.disable();
      }
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }
  }

  ngAfterViewInit(): void {
    this.isComponentLoading = false;
    this.changeLoadingState();
    if (this.isCalculator) {
      this.priceProductElement.nativeElement.focus();
      this.isCalculator = false;
    }
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.establishment) {
      this.reset();
    }
    this.changesDetected();
  }

  updateCombos(form: FormGroup) {
    if (form) {
      Object.keys(this.financingAmountDataForm.controls).forEach((key) => {
        if (form.controls[key] !== null) {
          this.financingAmountDataForm.controls[key].setValue(form.controls[key]?.value);
        }
      });
      this.isCombosUpdateLoading = false;
    }

    this.selectedProductLine = this.financingAmountDataForm.controls.lineProduct?.value;
    this.sendProductLine.emit(this.selectedProductLine);
    this.sendRequestedAmount.emit(this.financingAmountDataForm.controls.requestedAmount.value?.replace('€', '').trim());
    this.sendPriceProduct.emit(this.financingAmountDataForm.controls.priceProduct.value?.replace('€', '').trim());
    this.sendStart.emit(this.financingAmountDataForm.controls.start.value?.replace('€', '').trim());
  }

  setValuesToForm() {
    if (this.requestStore.getMarcaFormulario() === FORM_CONSUMO) {
      this.financingAmountDataForm.controls.priceProduct.setValue(this.request.productPrice + ' €');
      this.financingAmountDataForm.controls.requestedAmount.setValue(this.request.financedAmount + ' €');
      this.financingAmountDataForm.controls.start.setValue(this.request.entryAmount + ' €');
      this.financingAmountDataForm.controls.lineProduct.setValue(this.request.productLine);
      this.financingAmountDataForm.controls.product.setValue(this.request.product);
    } else {
      this.financingAmountDataForm.controls.priceProduct.setValue(this.request.amount);
      this.financingAmountDataForm.controls.requestedAmount.setValue(this.request.netPurchaseAmount);
      this.financingAmountDataForm.controls.start.setValue(this.request.entry);
      this.financingAmountDataForm.controls.lineProduct.setValue(this.request.typeVehicle);
      this.financingAmountDataForm.controls.product.setValue(this.request.product);
    }
  }

  calculateStart(event?: any) {
    let priceProduct = this.financingAmountDataForm.controls.priceProduct;
    let requestedAmount = this.financingAmountDataForm.controls.requestedAmount;
    let start = this.financingAmountDataForm.controls.start;

    if (
      priceProduct.value !== '' &&
      priceProduct.value !== null &&
      requestedAmount.value !== '' &&
      requestedAmount.value !== null
    ) {
      if (priceProduct.dirty || requestedAmount.dirty) {
        let amount = requestedAmount.value.toString().replaceAll('.', '').replace(',', '.');
        let price = priceProduct.value.toString().replaceAll('.', '').replace(',', '.');
        let startTotal = parseFloat(price) - parseFloat(amount);
        if (parseFloat(amount) <= parseFloat(price)) {
          if (startTotal >= 0) {
            if ((this.isRepsol || this.isGS) && amount > 1500) {
              priceProduct.setErrors(null);
              setTimeout(() =>
                this.financingAmountDataForm.controls.requestedAmount.setErrors({ repsolAmountInvalid: true })
              );
            } else {
              if (start?.value !== startTotal) {
                const result = this.customValidators.transformAmount(startTotal.toString().replace('.', ','));
                start.setValue(result);
              }
              requestedAmount.setErrors(null);
              priceProduct.setErrors(null);
            }
          }

          // video-selfing
          if (this.importeMaxVideoSelfing && requestedAmount) {
            this.videoSelfingIDInit =
              this.requestStore.getVideoSelfingID() != 'IMAX' ? this.requestStore.getVideoSelfingID() : '';
            let amountFormated = amount.replaceAll('.', '').replace(',', '.');
            if (amountFormated > this.importeMaxVideoSelfing) {
              this.requestStore.setVideoSelfingID('IMAX');
            } else {
              this.requestStore.setVideoSelfingID(this.videoSelfingIDInit);
            }
          }
        } else if (parseFloat(amount) > parseFloat(price)) {
          start.setValue('');
          setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ AmountInvalid: true }));
        }
        if (amount && this.maxAmount && this.isMaxAmountNotValid(parseFloat(amount))) {
          const result = this.customValidators.transformAmount(startTotal.toString().replace('.', ','));
          start.setValue(result);
          if (parseFloat(amount) < parseFloat(price)) {
            this.financingAmountDataForm.controls.requestedAmount.markAsTouched();
            setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ MaxAmount: true }));
          } else {
            this.financingAmountDataForm.controls.requestedAmount.setErrors({ MaxAmount: true });
          }
        } else {
          if (parseFloat(amount) < parseFloat(price)) {
            setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors(null));
          }
        }
      }
    } else {
      start.setValue('');
      if (event.target.id == 'priceProductFinancingAmount') {
        if (priceProduct.value == '' || priceProduct.value == null) {
          priceProduct.setErrors({ required: true });
        }
      }
      if (event.target.id == 'requestedAmountFinancingAmount') {
        if (requestedAmount.value == '' || requestedAmount.value == null) {
          requestedAmount.setErrors({ required: true });
        }
      }
    }
  }

  onLineProductSelected(event?: MatSelect) {
    this.isLineProductLoading = true;
    this.changeLoadingState();
    this.selectedProductLine = this.financingAmountDataForm.controls.lineProduct.value;
    if (this.selectedProductLine !== null && this.selectedProductLine !== undefined) {
      this.combosStore
        .loadProduct(this.selectedProductLine)
        .then(
          (data) => {
            this.productList = data;
            if (this.productList.length === 1) {
              this.financingAmountDataForm.controls.product.setValue(this.productList[0].id);
            }
          },
          () => {
            this.productList = null;
          }
        )
        .finally(() => {
          this.isLineProductLoading = false;
          this.changeLoadingState();
          if (this.requestStore.getFinanceAmountData()) {
            //send calculator data to request new
            let financeAmountData = this.requestStore.getFinanceAmountData();
            this.financingAmountDataForm.controls.priceProduct.setValue(financeAmountData.controls.priceProduct.value);
            this.financingAmountDataForm.controls.requestedAmount.setValue(
              financeAmountData.controls.requestedAmount.value
            );
            this.financingAmountDataForm.controls.start.setValue(financeAmountData.controls.start.value);
            this.financingAmountDataForm.controls.lineProduct.setValue(financeAmountData.controls.lineProduct.value);
            this.financingAmountDataForm.controls.product.setValue(financeAmountData.controls.product.value);
            this.requestStore.setFinanceAmountData(null);
          }
        });
      this.sendProductLine.emit(this.selectedProductLine);
    }
    this.isLineProductLoading = false;
    this.changeLoadingState();
  }

  changesDetected(): void {
    if (
      this.selectedEstablishment !== null &&
      this.selectedEstablishment !== undefined &&
      this.selectedEstablishment.length > 0
    ) {
      this.isChangesLoading = true;
      this.changeLoadingState();
      this.commercialProductList = null;
      this.lineProductList = null;
      this.financingAmountDataForm?.controls.lineProduct.setValue(null);
      this.financingAmountDataForm?.controls.lineProduct.setErrors(null);

      this.combosStore
        .loadLineProduct(this.selectedEstablishment)
        .then((data) => {
          this.lineProductList = data;
          if (this.lineProductList.length === 1) {
            this.financingAmountDataForm?.controls.lineProduct.setValue(this.lineProductList[0].id);
          }
          this.onLineProductSelected();
        })
        .finally(() => {
          this.isChangesLoading = false;
          this.changeLoadingState();
        });
      this.selectedEstablishment = null;
    }
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.financingAmountDataForm.controls[inputForm].value;

    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
  }

  private isMaxAmountNotValid(amount: any) {
    let finance = Number(this.typeBalance?.financial.replace('.', '').replace(',', '.'));
    let isEIC =
      this.typeBalance?.balance === TYPE_BALANCE_T ||
      (this.typeBalance?.balance === TYPE_BALANCE_S && amount < finance);
    return this.maxAmount && isEIC && amount > this.maxAmount;
  }

  transformAmount(value: any, element: any) {
    let amount = this.financingAmountDataForm.controls.requestedAmount.value
      ? this.financingAmountDataForm.controls.requestedAmount.value.toString().replaceAll('.', '').replace(',', '.')
      : null;
    let price = this.financingAmountDataForm.controls.priceProduct.value
      ? this.financingAmountDataForm.controls.priceProduct.value.toString().replaceAll('.', '').replace(',', '.')
      : null;

    let priceProduct = this.financingAmountDataForm.controls.priceProduct;
    let requestedAmount = this.financingAmountDataForm.controls.requestedAmount;
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;

    //Si ya estaba formateado el numero, quitamos lo que se añada por detras del simbolo €
    let cadena = '€';
    if (inputValue.includes(cadena)) {
      while (inputValue.substr(-1) != '€') {
        //limpiamos lo que se escriba detras de cadena
        inputValue = inputValue.slice(0, inputValue.length - 1);
      }
      //Limpiamos formateo para volver a formatear
      inputValue = inputValue.slice(0, inputValue.length - 1); //Limpieza simbolo €
      inputValue = inputValue.replaceAll('.', '');
    }
    //Existe la posibilidad de que el usuario elimine € y el formateo tenga un comportamiento extraño. En este caso limpiamos formato tambien
    cadena = '.';
    if (inputValue.includes(cadena)) {
      inputValue = inputValue.replaceAll('.', '');
    }

    if (inputValue > 999999999999) {
      if (inputForm == 'priceProduct') {
        priceProduct.setErrors({ max: true });
        this.priceValid = false;
        this.financingAmountDataForm.controls[inputForm].setValue('');
      }
      if (inputForm == 'requestedAmount') {
        requestedAmount.setErrors({ max: true });
        this.amountValid = false;
        this.financingAmountDataForm.controls[inputForm].setValue('');
      }
    } else {
      if (inputForm == 'priceProduct') {
        this.priceValid = true;
        priceProduct.setErrors(null);
      }
      if (inputForm == 'requestedAmount') {
        this.amountValid = true;
        requestedAmount.setErrors(null);
      }
      if (amount && price && parseFloat(amount) > parseFloat(price)) {
        setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ AmountInvalid: true }));
      } else if (
        amount &&
        this.maxAmount &&
        this.isMaxAmountNotValid(parseFloat(amount)) &&
        !(this.typeBalance.balance === TYPE_BALANCE_S)
      ) {
        setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ MaxAmount: true }));
      } else {
        setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors(null));
      }

      this.financingAmountDataForm.controls[inputForm].setValue(this.customValidators.transformAmount(inputValue));
    }
  }

  changeLoadingState() {
    if (!this.isComponentLoading && !this.isChangesLoading && !this.isLineProductLoading) {
      this.isFinishedLoading.emit({ formID: FINANCE_AMOUNT, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: FINANCE_AMOUNT, value: false });
    }
  }

  showRequestData() {
    let invalid: number = 0;
    Object.keys(this.financingAmountDataForm.controls).forEach((key) => {
      if (
        this.financingAmountDataForm.controls[key].value === null ||
        this.financingAmountDataForm.controls[key].value?.length === 0
      ) {
        invalid++;
        this.financingAmountDataForm.controls[key].setErrors({ required: true });
      }
    });
    if (
      !this.financingAmountDataForm.controls['priceProduct'].value.includes('€') ||
      !this.financingAmountDataForm.controls['requestedAmount'].value.includes('€')
    ) {
      invalid++;
    }

    if (invalid === 0 && !this.isDisableCalculateButton) {
      this.sendProductLine.emit(this.selectedProductLine);
      if (this.typeBalance.balance === TYPE_BALANCE_S && this.financingAmountDataForm.status === 'VALID') {
        if (
          Number(this.typeBalance.financial.replace('.', '').replace(',', '.')) >=
          Number(
            this.financingAmountDataForm.controls.requestedAmount.value
              .slice(0, -1)
              .trim()
              .replace('.', '')
              .replace(',', '.')
          )
        ) {
          this.sendOperative.emit({ value: OPERATIVE_EIC });
        } else {
          this.sendOperative.emit({ value: OPERATIVE_ESC });
        }
      }
      let amount = parseFloat(
        this.financingAmountDataForm.controls.requestedAmount.value.toString().replaceAll('.', '').replace(',', '.')
      );
      if (amount && this.maxAmount && this.isMaxAmountNotValid(amount)) {
        setTimeout(() => this.financingAmountDataForm.controls.requestedAmount.setErrors({ MaxAmount: true }));
      }
    } else {
      this.requestStore.listaFormulariosConsumo[POINT_OF_SALE]?.markAllAsTouched();
    }
  }

  private reset = () => {
    this.commercialProductList = [];
    this.lineProductList = [];
    this.financingAmountDataForm?.reset();
  };

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.financingAmountDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
